<div class="datasource-list-page">
  <div class="header">
    <div class="title">{{ title }}</div>
    <div class="refresh-btn">
      <button mat-raised-button class="btn" (click)="refreshTabsData()">REFRESH</button>
    </div>
  </div>
  <progress-spinner *ngIf="isLoading"></progress-spinner>
  <mat-tab-group class="users-tab-group" (selectedTabChange)="changeTab($event)">
    <mat-tab label="Devices" *ngIf="isFusionUI">
      <div class="nested-tab-group">
        <mat-tab-group
          class="users-tab-group"
          (selectedTabChange)="nestedTabchange($event)"
          [(selectedIndex)]="selectedNestedTabIndex"
        >
          <mat-tab label="Managed">
            <div class="tab-content">
              <progress-spinner *ngIf="isLoading"></progress-spinner>
              <div class="agent-link" *ngIf="hasReadWriteRole && !isFusionUI">
                <div class="agent-button" (click)="addAgent()">
                  <i class="icon mdi mdi-plus-circle"></i>
                  <span class="name">Add agent</span>
                </div>
                <div class="agent-button" (click)="downloadAgentWindow(true)">
                  <i class="icon mdi mdi-download-circle"></i>
                  <span class="name">Download agents</span>
                </div>
                <div class="agent-button" (click)="openProxyPopup(true)" *ngIf="!proxyUrl">
                  <i class="icon mdi mdi-plus-circle"></i>
                  <span class="name">Add agent control proxy</span>
                </div>
                <div class="agent-button" (click)="openProxyPopup(true)" *ngIf="proxyUrl">
                  <i class="icon mdi mdi-pencil"></i>
                  <span class="name">Edit agent control proxy</span>
                  <i matTooltip="{{ proxyUrl }}" class="icon mdi mdi-check-circle icon-check"></i>
                </div>
              </div>
              <ng-container *ngIf="agentDownloadOptionVisibility">
                <download-agent
                  (closeAgentDownloadFlyout)="downloadAgentWindow($event)"
                ></download-agent>
              </ng-container>
              <ng-container *ngIf="agentControlProxySelectionWindow">
                <agent-proxy
                  (closeAgentProxyContainer)="openProxyPopup($event)"
                  (proxyUrlToTooltip)="proxyUrlToTooltip($event)"
                ></agent-proxy>
              </ng-container>
              <div class="datasource-details-wrapper" *ngIf="hasData()">
                <div class="datasource-content" class="content-width-100">
                  <mat-card class="agent-data">
                    <ng-template #action>
                      <ng-container class="headline-action-button">
                        <button
                          [matMenuTriggerFor]="menu"
                          mat-button
                          class="action-button"
                          aria-label="Open menu"
                          [disabled]="isActionsDisabled"
                        >
                          <span
                            class="mat-button-wrapper"
                            matTooltip="Different type of agent can't be upgraded."
                            [matTooltipDisabled]="!isActionsDisabled || isActionsShowable"
                            ><i class="material-icons">more_horiz</i></span
                          >
                        </button>
                        <mat-menu #menu="matMenu">
                          <button
                            *ngIf="!isJmepBulkActionEnabled"
                            class="mat-menu-item-btn"
                            mat-menu-item
                            [disabled]="isUpgardeDisable"
                            (click)="upgradeAgent()"
                          >
                            <span>
                              <i class="mdi mdi-upload"></i>
                              Upgrade agent
                            </span>
                          </button>
                          <button
                            *ngIf="isJmepBulkActionEnabled"
                            mat-menu-item
                            class="mat-menu-item-btn"
                            (click)="jmepsBulkTransfer()"
                          >
                            <span>
                              <i class="mdi mdi-transit-transfer"></i>
                              Transfer Devices
                            </span>
                          </button>
                          <button
                            *ngIf="isJmepBulkActionEnabled"
                            mat-menu-item
                            class="mat-menu-item-btn"
                            (click)="removeBulkJmeps()"
                          >
                            <span>
                              <i class="mdi mdi-delete"></i>
                              Remove Devices
                            </span>
                          </button>
                        </mat-menu>
                      </ng-container>
                    </ng-template>
                    <div class="device-counters">
                      <div
                        class="count-item"
                        *ngFor="let item of deviceCounters"
                        [ngClass]="{ selected: item.id === selectedFilterItem }"
                        (click)="counterSelected(item)"
                      >
                        <div class="count" [class]="item.class">{{ item.count }}</div>
                        <div class="item-label">{{ item.label }}</div>
                      </div>
                    </div>
                    <div *ngIf="deviceAvailable" class="datasource-table">
                      <div class="esam-row" *ngIf="esamFiltered">
                        <div class="esam-title">Selected ESAM:</div>
                        <mat-chip (removed)="clearEsamFilter()" class="viavi-table-mat-chip">
                          {{ selectedEsamName }}
                          <button matChipRemove>
                            <mat-icon>cancel</mat-icon>
                          </button>
                        </mat-chip>
                      </div>
                      <viavi-table
                        [tableConfigurations]="table"
                        [isActionEnabled]="hasReadWriteRole"
                        [template]="action"
                        [resetCheckbox]="resetCheckbox"
                        (sendRowAction)="onActionClick($event)"
                        (sendPopupAction)="sendPopupAction($event)"
                        (rowClicked)="onTableRowClick($event)"
                        (onDataFiltered)="onTableFiltered($event)"
                      >
                      </viavi-table>
                    </div>
                  </mat-card>
                </div>
              </div>
              <div class="no-results" *ngIf="!hasData() && !isLoading">No records found</div>
            </div>
          </mat-tab>
          <mat-tab label="Unmanaged">
            <div *ngIf="nestedTabName === 'Unmanaged'" class="tab-content">
              <div class="unmanaged-device-header">
                <div class="agent-link" *ngIf="hasReadWriteRole">
                  <div class="agent-button" (click)="addDevice()">
                    <i class="icon mdi mdi-plus"></i>
                    <span class="name">Add</span>
                  </div>
                  <div class="agent-button" (click)="openImportModal()">
                    <i class="icon mdi mdi-upload"></i>
                    <span class="name">Import</span>
                  </div>
                  <div class="agent-button" (click)="exportDevice()">
                    <i class="icon mdi mdi-download"></i>
                    <span class="name">{{ unmanagedExportButtonLabel() }}</span>
                  </div>
                </div>
              </div>
              <div class="unmanaged-tab">
                <div class="datasource-table">
                  <nrwl-unmanaged-device-list
                    [refreshTable]="refreshTable"
                    [loadNewData]="loadNewData"
                    [exportUnmanagedDevice]="exportUnmanagedDevice"
                  ></nrwl-unmanaged-device-list>
                </div>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </mat-tab>
    <mat-tab label="Applications" *ngIf="isFusionUI && isPmTestEnabled">
      <div *ngIf="tabName === 'Applications'" class="tab-content">
        <nrwl-apps-page [refreshApplications]="refreshApplications"></nrwl-apps-page>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
